import React, { useEffect } from "react";
import { areas } from "../../helpers/areas";
import { MenuItem } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { SelectValidator } from "react-material-ui-form-validator";
import {
  fetchParentescos,
  fetchParentescosAutoGestion,
} from "../../actions/cbos/parentescos";
import { startAlerta } from "../../actions/ui/alertas";
import { PARENTESCOS } from "../../utils/constants";

export const CboParentescos = (props) => {
  const { items } = useSelector((state) => state.parentescos);
  const { usuarioAutogestion } = useSelector((state) => state.userAutogestion);
  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(usuarioAutogestion).length !== 0) {
      dispatch(fetchParentescosAutoGestion());
    } else {
      dispatch(fetchParentescos());
    }
    // eslint-disable-next-line
  }, []);

  const handleSelectChange = (e) => {
    if (e.target.value !== 0) {
      props.manejadorInputChange(e);
    } else {
      dispatch(startAlerta("Operacion No permitida desde este Form", "error"));
    }
  };

  const hayConcubino = props.grupoFamiliar?.find(
    (familiar) => familiar.id_parentesco === PARENTESCOS.CONCUBINA_O
  );
  const hayConyugue = props.grupoFamiliar?.find(
    (familiar) => familiar.id_parentesco === PARENTESCOS.CONYUGE
  );

  let parentescos = items;

  if (!hayConcubino && !hayConyugue) {
    parentescos = items.filter(
      (parentesco) =>
        parentesco.idParentesco !== PARENTESCOS.HIJO_CONYUGE &&
        parentesco.idParentesco !== PARENTESCOS.HIJO_CONYUGE_ESTUDIANTE
    );
  }

  return (
    <>
      <SelectValidator
        value={props.valor}
        name="id_parentesco"
        disabled={
          props.esReactivacion ? true :
          props.idPanel === "idTabConsulta" ||
            (props.idPanel === "idTabAfiliacion" && props.valor === 0) ||
            props.valor === 0 ||
            props.fromBandejaFamiliar ||
            (props.fromBandeja && idAreaUsuario === areas.Nacional)
            ? true
            : false
        }
        onChange={(e) => {
          handleSelectChange(e);
        }}
        margin="normal"
        fullWidth
        label="Parentesco"
        validators={["required"]}
        errorMessages={["Seleccione una opcion"]}
      >
        <MenuItem value="">
          <em>Seleccione</em>
        </MenuItem>
        {parentescos.map((t) => (
          <MenuItem key={t.idParentesco} value={t.idParentesco}>
            {t.descripcionParentesco}
          </MenuItem>
        ))}
      </SelectValidator>
    </>
  );
};
